<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> ESIC Dispensary</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm"  routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>
            <!--end header-->
           

             <div class="row row-replace m-t-30">
                 <div class="col-12">
                        <p class="h5">Please click on below link to know ESIC Dispensary and book your Appointment to avail benefit - <a href="https://www.esichospitals.gov.in/" target="_blank">https://www.esichospitals.gov.in/</a>
                            </p>
                            <p class="h4">ESIC Helpline No : 1800-11-3839</p>

                    </div>
             </div>

             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

